module.exports = __webpack_public_path__ + "static/img/fanhui_btn.aa525ba9.png";